import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CurrentUserAreasApi } from '../data-access/current-user-areas.api';
import { UserService } from './user.service';
import { AreaContextService } from './area-context.service';
import { AuthService } from './auth.service';
import { BannerService } from './banner.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly auth = inject(AuthService);
  private readonly currentUserAreasApi = inject(CurrentUserAreasApi);
  private readonly user = inject(UserService);
  private readonly areaContext = inject(AreaContextService);
  private readonly banners = inject(BannerService);

  async initialize(): Promise<void> {
    const account = this.auth.getActiveAccount();
    if (!account) {
      return;
    }

    const claims = account.idTokenClaims as any;

    this.user.setRoles(claims.roles ?? []);
    this.user.setUser(claims.name, claims.preferred_username);

    try {
      const areas = await firstValueFrom(this.currentUserAreasApi.getAll());
      this.user.setAreas(areas);
      this.areaContext.initialize(areas);
    } catch (error) {
      console.warn('Unable to load current user areas', error);
      this.user.setAreas([]);
      this.areaContext.initialize([]);
    }

    await this.banners.load(this.areaContext.selectedAreaId());

    await this.user.fetchPhoto();
  }
}
